<template>
  <div
    class="flex items-start h-10 w-full top-0 z-10 inset-x-0 p-2 font-bold text-bnb-mustard text-left text-lg shadow-lg bg-white"
  >
    <img
      alt="back"
      src="@/assets/icons/chevronright.svg"
      class="h-6 mr-2 transform rotate-180"
      @click="$router.go(-1)"
    />
    <img alt="logo" src="@/assets/logosquare.png" class="h-6 mr-2" />
    <p>{{ title }}</p>
  </div>
</template>

<script>
export default {
  props: { title: String },
};
</script>
